import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./MenuGrid.css";
import { BASE_URL } from "../../api/api";
import { useCart } from "../../context/CartContext";

const MenuGrid = ({
  items,
  onAddToCart,
  title = "Trending Now",
  subtitle = "Most popular items this week",
}) => {
  const { activeOrder, cart, updateQuantity, getItemQuantity } = useCart();
  const isOrderActive = !!activeOrder;

  const navigate = useNavigate();
  const [msg, setMsg] = useState("");

  const handleItemClick = (itemId) => {
    navigate(`/item/${itemId}`);
  };

  // Handle quantity change
  const handleQuantityChange = (item, newQuantity, e) => {
    e.stopPropagation();

    if (activeOrder) {
      setMsg("🍽️ Order in progress");
      setTimeout(() => setMsg(""), 1500);
      return;
    }

    if (newQuantity > 0) {
      const existingQuantity = getItemQuantity(item.id);
      if (existingQuantity > 0) {
        updateQuantity(item.id, newQuantity);
      } else {
        onAddToCart(item);
      }
      setMsg(
        `${item.item_name} ${newQuantity > existingQuantity ? "added" : "updated"} ✅`,
      );
    } else {
      updateQuantity(item.id, 0);
      setMsg(`${item.item_name} removed ❌`);
    }
    setTimeout(() => setMsg(""), 1500);
  };

  if (!items || items.length === 0) {
    return (
      <div className="menu-section">
        <div className="section-header">
          <div>
            <h3 className="section-title">{title}</h3>
            <p className="section-subtitle">{subtitle}</p>
          </div>
        </div>
        <div className="empty-state">
          <div className="empty-icon">🍽️</div>
          <p>No items available in this category</p>
        </div>
      </div>
    );
  }

  return (
    <div className="menu-section">
      <div className="section-header">
        <div>
          <h3 className="section-title">{title}</h3>
          <p className="section-subtitle">{subtitle}</p>
        </div>
        <button className="see-all" onClick={() => navigate("/category")}>
          See All →
        </button>
      </div>
      {msg && <div className="cart-msg">{msg}</div>}
      <div className="menu-grid">
        {items.map((item) => {
          const currentQuantity = getItemQuantity(item.id);
          return (
            <div
              key={item.id}
              className="food-card glass-card"
              onClick={() => handleItemClick(item.id)}>
              <div className="food-image">
                {item.image ? (
                  <img src={`${BASE_URL}/${item.image}`} alt={item.item_name} />
                ) : (
                  <div className="food-emoji">🍔</div>
                )}
                <div className="food-badge">⭐ {item.rating || 4.5}</div>
              </div>
              <div className="food-info">
                <h4>{item.item_name}</h4>
                <p className="food-desc">
                  {item.description || "Delicious & fresh"}
                </p>
                <div className="food-footer">
                  <span className="food-price">₹{item.price}</span>

                  {/* ZOMATO STYLE QUANTITY CONTROLS */}
                  {currentQuantity > 0 ? (
                    <div className="quantity-controls">
                      <button
                        className="qty-btn minus"
                        onClick={(e) =>
                          handleQuantityChange(item, currentQuantity - 1, e)
                        }>
                        −
                      </button>
                      <span className="qty-count">{currentQuantity}</span>
                      <button
                        className="qty-btn plus"
                        onClick={(e) =>
                          handleQuantityChange(item, currentQuantity + 1, e)
                        }>
                        +
                      </button>
                    </div>
                  ) : (
                    <button
                      className="add-btn"
                      onClick={(e) => handleQuantityChange(item, 1, e)}>
                      +
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MenuGrid;
